/* eslint-disable react/prop-types */
// @ts-nocheck
import React, { Component } from 'react';
import { t } from '../../locales/i18n';

export class CommentAdd extends Component {
  constructor(props) {
    super(props);
    this.state = { ...this.stateFromProps(props), text: '' };
  }

  stateFromProps(props) {
    return {
      queueNumber: props.queueNumber,
      ticketUUID: props.ticketUUID
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.stateFromProps(nextProps));
  }

  handleTextKeyUp = (event) => {
    const modifierPressed = event.altKey || event.ctrlKey;
    const keyCode = event.keyCode;
    if (keyCode === 13 && !modifierPressed) {
      this.props.onCommentInsert(this.state);
      this.setState({ text: '' });
    }
  };

  handleTextChanged = (event) => {
    const text = event.target.value;
    this.setState({ text });
    this.props.onChange({ ...this.state, text });
  };

  render() {
    const viewType = this.props.simpleView ? 'simpleView' : 'fullView';
    const hintText = t(`addComment.${viewType}`, {
      ticketNumber: this.props.ticketNumber
    });
    return (
      <div>
        <input
          placeholder={hintText}
          type="text"
          value={this.state.text}
          onKeyUp={this.handleTextKeyUp}
          onChange={this.handleTextChanged}
        />
      </div>
    );
  }
}
